import module from 'finanzas/module.js'
import template from './template.html'

function FinancesPosicionbancariaPrestamoDocumentosComponent () {
  var $ctrl = this

  $ctrl.agregando = false
  $ctrl.agregar = agregar
  $ctrl.eliminar = eliminar

  function agregar (data) {
    if (!$ctrl.agregando) {
      $ctrl.agregando = true

      return
    }

    if (data) {
      $ctrl.data.push(data)
    }

    $ctrl.agregando = false
  }

  function eliminar (data) {
    $ctrl.data.splice($ctrl.data.indexOf(data), 1)
  }
}

module.component('financesPosicionbancariaPrestamoDocumentos', {
  controller: FinancesPosicionbancariaPrestamoDocumentosComponent,
  template,
  bindings: {
    idEmpresa: '<',
    idCuenta: '<',
    idPrestamo: '<',
    data: '<',
  },
})



// WEBPACK FOOTER //
// ./src/finanzas/components/posicionbancaria/prestamo/documentos/component.js